var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 49,
    viewBox: "0 0 115 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92689 17.444L8.03954 18.7419C8.03954 18.7419 9.1541 13.6042 14.5086 14.6687C15.5436 14.8567 16.4946 15.3618 17.2299 16.1141C17.9652 16.8664 18.4485 17.8287 18.6128 18.8677C18.7696 19.7423 18.7153 20.6417 18.4544 21.491C18.1936 22.3404 17.7337 23.1152 17.113 23.7511C15.7037 25.2408 13.095 26.3031 9.13495 24.6841L6.14362 38.4684L12.1892 39.7723L13.9265 31.6973C13.9265 31.6973 22.8904 31.3461 24.9141 22.0044C26.8506 13.0637 19.2844 9.24725 15.851 8.5029C13.2444 7.93669 4.15137 6.63431 1.92689 17.444Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6415 42.6345L5.50488 41.3042L4.26272 47.0341L10.3993 48.3644L11.6415 42.6345Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.235 5.76817L107.628 5.15617C107.555 4.88441 107.537 4.60074 107.576 4.32202C107.615 4.0433 107.709 3.77523 107.854 3.53372C107.998 3.29222 108.19 3.08223 108.417 2.91622C108.644 2.75022 108.902 2.6316 109.176 2.56741C109.575 2.44705 110.001 2.45367 110.396 2.58635C110.791 2.71903 111.135 2.9712 111.38 3.30793C111.588 3.58752 111.727 3.91237 111.785 4.25592C111.844 4.59948 111.82 4.952 111.716 5.28469C111.49 6.06193 110.761 6.90649 109.072 7.04725L110.498 12.439L112.861 11.827L112.028 8.66905C112.924 8.12873 113.617 7.30874 114.001 6.33549C114.385 5.36224 114.438 4.28978 114.152 3.28345C113.234 -0.217191 109.868 -0.198831 108.54 0.150009C107.512 0.388689 104.078 1.55761 105.235 5.76817Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.694 12.6133L111.284 13.2593L111.887 15.5092L114.297 14.8631L113.694 12.6133Z",
    fill: "#EBEBEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.cab0e9032ed29a657fa669d474aea9aa.svg";
export { ForwardRef as ReactComponent };